import { Component, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { ConfigService } from './services/config/config.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'ventas';
  token: any = {};
  display: boolean = false;
  displayHelp: boolean = false;
  message: string = "";
  load: boolean = false;
  showInfo: boolean = true;
  version: string = "";

  constructor(private primeng: PrimeNG, private config: ConfigService) {
    if (!localStorage.getItem('empresa'))
      this.showInfo = false;
  }



  ngOnInit(): void {
    /// con esta pagina https://www.accio.tools/magic/color-shades-generator se realiza el cambio de color en base a la palette

    const MyPreset = definePreset(Material, {
      semantic: {
        semantic: {
          primary: {
            50: '#fbeaec',
            100: '#f3bfc6',
            200: '#eb94a0',
            300: '#e2697a',
            400: '#da3e54',
            500: '#c1253b',
            600: '#961d2e',
            700: '#6b1421',
            800: '#400c14',
            900: '#150407',
          }
        }
      }
    });

    this.primeng.theme.set({
      preset: MyPreset,
      options: {
        darkModeSelector: false || 'none'
      }
    });

    this.config.getversion().subscribe({
      next: (response) => {
        this.version = ((response as any)?.version ?? "");
        console.log(this.version);

        if (!sessionStorage.getItem('version')) {
          console.log(sessionStorage.getItem('version'));
          sessionStorage.setItem('version', this.version);
          window.location.reload();
        }
        else {
          console.log('versión ', sessionStorage.getItem('version'));
          if (sessionStorage.getItem('version') != this.version) {
            console.log('versión anterior');
            localStorage.clear();
            sessionStorage.setItem('version', this.version);
            window.location.reload();
          }
        }

      },
      error: (error: HttpErrorResponse) => { console.log(error) }
    })
  }

  reload = () => {
    localStorage.clear();
    //window.location.href = this.config.urlHome.toString();
  }

  openHelp = () => {
    this.displayHelp = true;
  }
}
